import { render } from "./employee-followup-details.vue?vue&type=template&id=24719994&scoped=true"
import script from "./employee-followup-details.vue?vue&type=script&lang=js"
export * from "./employee-followup-details.vue?vue&type=script&lang=js"

import "./employee-followup-details.vue?vue&type=style&index=0&id=24719994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24719994"]])

export default __exports__